import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';
import {VayuBlockAdvanceStyle} from '@vayu-blocks/advance-panel/style.js';

export default function AdvanceSettings({ children, attributes,clientId}) {
    const { mergedStyles, handleMouseEnter, handleMouseLeave,responsiveClasses, hoverAnimationClass } = VayuBlockAdvanceStyle(attributes);

    const blockProps = useBlockProps({
        className: `block-${clientId} ${hoverAnimationClass} ${responsiveClasses}`,
        style: {
            ...mergedStyles,
            '--pagination-active-color-post-grid-vayu-blocks': attributes.pg_PaginationactiveColor,
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
    });
    
    return (
        <div {...blockProps}>
            {children}
        </div>
    );
}